@if (results()) {
<div class="w-full h-full flex flex-col">
  <!-- Header dos Resultados -->
  <app-lesson-header
    icon="bi-clipboard-data"
    iconColor="text-blue-500"
    title="Resultado da Avaliação"
    subtitle="Confira seu desempenho e feedback detalhado"
    [module]="module"
    [showModuleInfo]="true"
    additionalClasses="flex-shrink-0"
  >
  </app-lesson-header>

  <!-- Conteúdo dos Resultados -->
  <div
    class="flex-1 min-h-0 overflow-y-auto p-6 bg-gray-50 dark:bg-neutral-900"
  >
    <div class="max-w-5xl mx-auto space-y-8">
      <!-- Resumo Geral -->
      <div
        class="rounded border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50 p-6"
      >
        <div class="text-center">
          <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4">
            Resultado da Avaliação
          </h3>

          <!-- Nota -->
          <div class="mb-6">
            <div
              class="text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2"
            >
              {{ results()!.totalScore }} / {{ results()!.totalPoints }} pontos
            </div>
            <div
              class="text-2xl font-semibold text-gray-700 dark:text-neutral-300"
            >
              {{ results()!.percentage }}%
            </div>
          </div>

          <!-- Mensagem de Feedback -->
          <p class="text-base text-gray-700 dark:text-neutral-300">
            {{ feedbackMessage }}
          </p>
        </div>
      </div>

      <!-- Feedback Detalhado por Questão -->
      <div class="space-y-6">
        <h4 class="text-lg font-semibold text-gray-900 dark:text-white">
          Feedback Detalhado
        </h4>

        @for (questionResult of getOrderedQuestionResults(); track
        questionResult.questionId) {
        <div class="content-card p-6">
          <!-- Cabeçalho da Questão -->
          <div class="mb-4">
            <h5
              class="text-base font-semibold text-gray-900 dark:text-white mb-3"
            >
              {{ getQuestionText(questionResult.questionId,
              questionResult.lessonId) }}
            </h5>
          </div>

          <!-- Respostas Selecionadas -->
          <div class="mb-4">
            <p
              class="text-sm font-medium text-gray-700 dark:text-neutral-300 mb-2"
            >
              Suas respostas:
            </p>
            @if (questionResult.selectedAnswers &&
            questionResult.selectedAnswers.length > 0) {
            <div class="space-y-2">
              @for (selectedId of
              getOrderedSelectedAnswers(questionResult.selectedAnswers); track
              selectedId) {
              <div
                class="flex items-center gap-2 rounded border p-3"
                [class]="isCorrectAnswer(questionResult.questionId, selectedId, questionResult.lessonId) 
                           ? 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800' 
                           : 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800'"
              >
                <i
                  [class]="isCorrectAnswer(questionResult.questionId, selectedId, questionResult.lessonId) 
                        ? 'bi bi-check-circle-fill text-green-600 dark:text-green-400' 
                        : 'bi bi-x-circle-fill text-red-600 dark:text-red-400'"
                ></i>
                <span class="text-sm text-gray-900 dark:text-white">
                  {{ getOptionText(questionResult.questionId, selectedId,
                  questionResult.lessonId) }}
                </span>
                @if (isCorrectAnswer(questionResult.questionId, selectedId,
                questionResult.lessonId)) {
                <span
                  class="ml-auto text-xs font-medium text-green-600 dark:text-green-400"
                >
                  Correto
                </span>
                } @else {
                <span
                  class="ml-auto text-xs font-medium text-red-600 dark:text-red-400"
                >
                  Incorreto
                </span>
                }
              </div>
              }
            </div>
            } @else {
            <p class="text-sm text-gray-500 dark:text-neutral-400 italic">
              Nenhuma resposta selecionada.
            </p>
            }
          </div>

          <!-- Resultado da Questão -->
          <div class="pt-4 border-t border-gray-200 dark:border-neutral-700">
            @if (questionResult.correct) {
            <div
              class="flex items-center gap-2 text-green-600 dark:text-green-400"
            >
              <i class="bi bi-check-circle-fill"></i>
              <span class="text-sm font-medium">
                Correto! Você ganhou {{ questionResult.points }} ponto(s).
              </span>
            </div>
            } @else {
            <div class="space-y-3">
              <div
                class="flex flex-row items-center justify-between gap-2 text-red-600 dark:text-red-400"
              >
                <div class="flex items-center gap-2">
                  <i class="bi bi-x-circle-fill"></i>
                  <span class="text-sm font-medium">
                    Incorreto. Pontos: 0
                  </span>
                </div>
                @if (questionResult.correctCount !== undefined &&
                questionResult.incorrectCount !== undefined) {
                <div class="flex items-center gap-4 text-xs">
                  <div class="text-blue-500">
                    Opções selecionadas: {{ questionResult.correctCount +
                    questionResult.incorrectCount }}
                  </div>
                  <div class="text-green-500">
                    Opções corretas: {{ questionResult.correctCount }}
                  </div>
                  <div class="text-red-500">
                    Opções incorretas: {{ questionResult.incorrectCount }}
                  </div>
                </div>
                }
              </div>

              @if (shouldShowMultipleChoiceWarning(questionResult)) {
              <div
                class="pt-4 border-t border-gray-200 dark:border-neutral-700"
              >
                <div class="flex items-start gap-2">
                  <i
                    class="bi bi-info-circle-fill text-yellow-600 dark:text-yellow-400 flex-shrink-0"
                  ></i>
                  <p class="text-sm text-yellow-800 dark:text-yellow-300">
                    <strong>Importante:</strong> Em questões onde você pode
                    escolher 1 ou mais opções, é necessário marcar
                    <strong>todas</strong> as alternativas corretas e
                    <strong>nenhuma</strong> incorreta para ganhar pontos. Mesmo
                    acertando algumas opções, se houver alguma incorreta
                    selecionada ou faltar alguma correta, a questão será
                    considerada incorreta.
                  </p>
                </div>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
} @else {
<div
  class="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
>
  <div class="text-center">
    <i
      class="bi bi-clipboard-data text-gray-400 dark:text-neutral-600 text-6xl mb-4"
    ></i>
    <p class="text-gray-500 dark:text-neutral-400">
      Nenhum resultado disponível
    </p>
    <p class="text-sm text-gray-400 dark:text-neutral-500 mt-2">
      Complete a avaliação para ver os resultados
    </p>
  </div>
</div>
}
